import { cn } from "helper/Utils";
import React from "react";

const VARIANT_CLASSES = {
  default: "bg-white/15 text-white/60",
  success: "text-white bg-secondary border border-secondary",
  danger: "text-white bg-[rgb(255,52,73,0.2)]",
};
export const FormMessage = ({ variant = "danger", className, message }) => {
  const variantClass = VARIANT_CLASSES[variant] || VARIANT_CLASSES.default;
  return <p className={cn("text-[12px] p-1 mt-[2px] rounded-md", className, variantClass)}>{message}</p>;
};
